(function () {
  var $$ = function (r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); };

  function dinheiro(c, fmt) {
    var v = (Math.round(c) / 100).toFixed(2).split('.');
    var mil = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var txt = mil + ',' + v[1];
    if (fmt && fmt.indexOf('{{') > -1) return fmt.replace(/\{\{\s*\w+\s*\}\}/, txt);
    return 'R$ ' + txt;
  }

  function addItens(itens, erroEl) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: itens })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (e) {
        if (erroEl) { erroEl.hidden = false; erroEl.textContent = (e && (e.description || e.message)) || 'Não foi possível adicionar. Tente de novo.'; }
      });
  }

  function trocaKitImg(s) {
    if (s.tagName !== 'SELECT') return;
    var o = s.options[s.selectedIndex], row = s.closest('[data-lj-kitrow], .lj-lk__it'), im = row && row.querySelector('[data-lj-kitimg]');
    if (im && o && o.dataset.img) im.src = o.dataset.img;
  }

  function hero(el) {
    var sl = $$(el, '.lj-hs__sl'), dots = $$(el, '.lj-hs__dots button'), cur = 0;
    if (sl.length < 2) return;
    var mostra = function (i) { cur = i; sl.forEach(function (e, k) { e.classList.toggle('on', k === i); }); dots.forEach(function (e, k) { e.classList.toggle('on', k === i); }); };
    dots.forEach(function (d, i) { d.addEventListener('click', function () { mostra(i); }); });
    setInterval(function () { mostra((cur + 1) % sl.length); }, (+el.dataset.tempo || 6) * 1000);
  }

  function vitrine(el) {
    var tracks = $$(el, '.lj-vt__track'), bar = el.querySelector('.lj-vt__bar i'), all = el.querySelector('[data-lj-all]');
    var ativo = function () { return tracks.filter(function (t) { return !t.hidden; })[0]; };
    var upd = function () { var t = ativo(); if (!t || !bar) return; var w = t.clientWidth / Math.max(t.scrollWidth, 1); bar.style.width = Math.min(w * 100, 100) + '%'; bar.style.transform = 'translateX(' + (t.scrollLeft / t.clientWidth * 100) + '%)'; };
    tracks.forEach(function (t) { t.addEventListener('scroll', upd, { passive: true }); });
    $$(el, '.lj-vt__tab').forEach(function (b) {
      b.addEventListener('click', function () {
        $$(el, '.lj-vt__tab').forEach(function (x) { x.classList.toggle('on', x === b); });
        tracks.forEach(function (t) { t.hidden = t.dataset.i !== b.dataset.i; });
        if (all && b.dataset.url) all.href = b.dataset.url;
        var t = ativo(); if (t) t.scrollLeft = 0; upd();
      });
    });
    $$(el, '.lj-vt__nav [data-d]').forEach(function (b) { b.addEventListener('click', function () { var t = ativo(); if (t) t.scrollLeft += (+b.dataset.d) * t.clientWidth; }); });
    upd(); window.addEventListener('resize', upd);
  }

  function monte(el) {
    var its = $$(el, '.lj-lk__it'), tot = el.querySelector('[data-lj-total]');
    $$(el, '.lj-lk__pt').forEach(function (p) {
      var marca = function (on) { its.forEach(function (x) { x.classList.toggle('on', on && x.dataset.lki === p.dataset.lk); }); p.classList.toggle('on', on); };
      p.addEventListener('mouseenter', function () { marca(true); });
      p.addEventListener('mouseleave', function () { marca(false); });
      p.addEventListener('click', function () { var it = its.filter(function (x) { return x.dataset.lki === p.dataset.lk; })[0]; if (it) { var a = it.querySelector('a'); if (a) window.location.href = a.href; } });
    });
    var soma = function () {
      var t = 0;
      $$(el, '[data-lj-var]').forEach(function (s) {
        var o = s.tagName === 'SELECT' ? s.options[s.selectedIndex] : s; var c = +o.dataset.preco || 0; t += c;
        var pr = s.closest('span').querySelector('[data-lj-preco]'); if (pr) pr.textContent = dinheiro(c);
      });
      if (tot) tot.textContent = dinheiro(t);
    };
    $$(el, 'select[data-lj-var]').forEach(function (s) { s.addEventListener('change', function () { trocaKitImg(s); soma(); }); });
    var btn = el.querySelector('[data-lj-addall]');
    if (btn) btn.addEventListener('click', function () {
      btn.disabled = true;
      var itens = $$(el, '[data-lj-var]').map(function (s) { return { id: +s.value, quantity: 1 }; });
      addItens(itens, el.querySelector('[data-lj-err]')).then(function () { btn.disabled = false; });
    });
  }

  function colecao(el) {
    var fl = el.querySelector('[data-lj-fl]');
    var aplica = function () {
      var p = new URLSearchParams(new FormData(fl));
      $$(fl, 'input[type=number]').forEach(function (i) { if (!i.value) p.delete(i.name); });
      window.location.href = fl.action + '?' + p.toString();
    };
    if (fl) {
      $$(fl, 'input[type=checkbox]').forEach(function (i) { i.addEventListener('change', aplica); });
      $$(fl, 'input[type=number]').forEach(function (i) { i.addEventListener('change', aplica); });
      var ab = el.querySelector('[data-lj-flopen]'), fe = el.querySelector('[data-lj-flclose]');
      if (ab) ab.addEventListener('click', function () { fl.classList.add('on'); document.documentElement.style.overflow = 'hidden'; });
      if (fe) fe.addEventListener('click', function () { fl.classList.remove('on'); document.documentElement.style.overflow = ''; });
    }
    var so = el.querySelector('[data-lj-sort]');
    if (so) so.addEventListener('change', function () { var u = new URL(window.location.href); u.searchParams.set('sort_by', so.value); u.searchParams.delete('page'); window.location.href = u.toString(); });
  }

  function produto(el) {
    var P = JSON.parse(el.querySelector('[data-lj-json]').textContent);
    var fmt = el.dataset.money, pixf = +el.dataset.pix || 1, juros = +el.dataset.juros || 1;
    var form = el.querySelector('[data-lj-form]'), idIn = el.querySelector('[data-lj-id]'), qty = el.querySelector('[data-lj-qty]');
    var buy = el.querySelector('[data-lj-buy]'), buyTxt = el.querySelector('[data-lj-buytxt]'), txtCompra = buyTxt ? buyTxt.textContent : '';
    var main = el.querySelector('[data-lj-main]');
    var grupos = $$(el, '[data-lj-op]');
    var atual = P.variants.filter(function (x) { return x.id === +idIn.value; })[0] || P.variants[0];
    var escolhas = atual.options.slice();

    var acha = function (ops) { return P.variants.filter(function (x) { return x.options.every(function (o, i) { return o === ops[i]; }); })[0]; };
    var q = function (s) { return el.querySelector(s); };
    var set = function (s, t) { var e = q(s); if (e) e.textContent = t; };

    function trocaFoto(src, id) {
      if (main && src) main.src = src;
      $$(el, '.lj-ga__th button').forEach(function (b) { b.classList.toggle('on', String(b.dataset.media) === String(id)); });
    }
    $$(el, '.lj-ga__th button').forEach(function (b) { b.addEventListener('click', function () { trocaFoto(b.dataset.src, b.dataset.media); }); });
    $$(el, '[data-lj-arr]').forEach(function (a) {
      a.addEventListener('click', function () {
        var th = $$(el, '.lj-ga__th button'); if (!th.length) return;
        var i = th.findIndex(function (b) { return b.classList.contains('on'); });
        var n = th[(i + (+a.dataset.ljArr) + th.length) % th.length];
        trocaFoto(n.dataset.src, n.dataset.media); n.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    });

    var ent = q('[data-lj-ent]');
    if (ent) {
      var cid = q('[data-lj-cidade]');
      if (cid) {
        var poe = function (r) { if (r) cid.innerHTML = 'Envio para <b>' + r + ' e Região</b>'; };
        var salvo = null; try { salvo = sessionStorage.getItem('lj-cidade'); } catch (e) {}
        if (salvo) poe(salvo); else fetch('https://wtfismyip.com/json').then(function (r) { return r.json(); }).then(function (j) {
          var l = (j.YourFuckingLocation || '').replace(/, Brazil$/, '').trim(); if (!l || /,/.test(l) === false && l.length < 3) return;
          try { sessionStorage.setItem('lj-cidade', l); } catch (e) {} poe(l);
        }).catch(function () {});
      }
    }

    function marcaIndisponiveis() {
      grupos.forEach(function (g) {
        var i = +g.dataset.ljOp;
        $$(g, '[data-v]').forEach(function (b) {
          var ops = escolhas.slice(); ops[i] = b.dataset.v; var x = acha(ops);
          b.classList.toggle('x', !x || !x.available);
          var kp = b.querySelector('[data-lj-kp]'), kc = b.querySelector('[data-lj-kc]');
          if (kp) kp.textContent = x ? dinheiro(x.price, fmt) : '';
          if (kc) kc.textContent = x && x.compare_at_price > x.price ? dinheiro(x.compare_at_price, fmt) : '';
        });
      });
    }

    function kitTotal() {
      var k = q('[data-lj-kit]'); if (!k) return;
      var n = 1, t = atual.price;
      set('[data-lj-kitself]', dinheiro(atual.price, fmt));
      $$(k, '[data-lj-kitrow]').forEach(function (r) {
        var s = r.querySelector('[data-lj-var]'), o = s.tagName === 'SELECT' ? s.options[s.selectedIndex] : s, c = +o.dataset.preco || 0;
        r.querySelector('[data-lj-kitpreco]').textContent = dinheiro(c, fmt);
        if (r.querySelector('[data-lj-kitck]').checked) { n++; t += c; }
      });
      set('[data-lj-kitn]', n); set('[data-lj-kittot]', dinheiro(t, fmt));
      set('[data-lj-kitsub]', (pixf < 1 ? dinheiro(t * pixf, fmt) + ' no Pix · ' : '') + 'ou 12x de ' + dinheiro(t * juros / 12, fmt) + ' no cartão');
    }

    function aplica(v) {
      if (!v) { if (buy) buy.disabled = true; if (buyTxt) buyTxt.textContent = 'Indisponível'; return; }
      atual = v; idIn.value = v.id;
      set('[data-lj-preco]', dinheiro(v.price, fmt)); set('[data-lj-stkp]', dinheiro(v.price, fmt));
      var tem = v.compare_at_price && v.compare_at_price > v.price;
      set('[data-lj-de]', tem ? dinheiro(v.compare_at_price, fmt) : '');
      var off = q('[data-lj-off]'); if (off) { off.hidden = !tem; off.textContent = tem ? '−' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%' : ''; }
      var eco = q('[data-lj-eco]'); if (eco) { eco.hidden = !tem; eco.textContent = tem ? 'Economize ' + dinheiro(v.compare_at_price - v.price, fmt) : ''; }
      set('[data-lj-parc]', dinheiro(v.price * juros / 12, fmt));
      set('[data-lj-pix]', dinheiro(v.price * pixf, fmt));
      if (pixf < 1) set('[data-lj-stkpix]', dinheiro(v.price * pixf, fmt) + ' no Pix');
      if (buy) buy.disabled = !v.available;
      if (buyTxt) buyTxt.textContent = v.available ? txtCompra : 'Esgotado';
      if (v.featured_media) trocaFoto(v.featured_media.preview_image && v.featured_media.preview_image.src ? v.featured_media.preview_image.src + (v.featured_media.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1400' : null, v.featured_media.id);
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      marcaIndisponiveis(); kitTotal();
    }

    grupos.forEach(function (g) {
      var i = +g.dataset.ljOp;
      $$(g, '[data-v]').forEach(function (b) {
        b.addEventListener('click', function () {
          escolhas[i] = b.dataset.v;
          $$(g, '[data-v]').forEach(function (x) { x.classList.toggle('on', x === b); });
          var lb = q('[data-lj-opv="' + i + '"]'); if (lb) lb.textContent = b.dataset.label || b.textContent.trim() || b.title;
          var v = acha(escolhas);
          if (!v || !v.available) {
            var alt = P.variants.filter(function (x) { return x.available && x.options[i] === escolhas[i]; })[0];
            if (alt) {
              escolhas = alt.options.slice(); v = alt;
              grupos.forEach(function (gg) { var k = +gg.dataset.ljOp; $$(gg, '[data-v]').forEach(function (x) { x.classList.toggle('on', x.dataset.v === escolhas[k]); }); var l = q('[data-lj-opv="' + k + '"]'); var on = gg.querySelector('.on'); if (l && on) l.textContent = on.dataset.label || on.textContent.trim() || on.title; });
            }
          }
          aplica(v);
        });
      });
    });

    $$(el, '[data-lj-q]').forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, (+qty.value || 1) + (+b.dataset.ljQ)); }); });

    var k = q('[data-lj-kit]');
    if (k) {
      $$(k, '[data-lj-kitck], select[data-lj-var]').forEach(function (i) { i.addEventListener('change', function () { trocaKitImg(i); kitTotal(); }); });
      var kb = k.querySelector('[data-lj-kitbuy]');
      kb.addEventListener('click', function () {
        kb.disabled = true;
        var itens = [{ id: atual.id, quantity: Math.max(1, +qty.value || 1) }];
        $$(k, '[data-lj-kitrow]').forEach(function (r) { if (r.querySelector('[data-lj-kitck]').checked) itens.push({ id: +r.querySelector('[data-lj-var]').value, quantity: 1 }); });
        addItens(itens, k.querySelector('[data-lj-err]')).then(function () { kb.disabled = false; });
      });
    }

    var stk = q('[data-lj-stk]');
    if (stk && buy) {
      q('[data-lj-stkbuy]').addEventListener('click', function () { buy.click(); });
      var b2 = q('[data-lj-buy2]'); if (b2) b2.addEventListener('click', function () { buy.click(); });
      var vis = function () { var r = buy.getBoundingClientRect(); var fora = r.bottom < 0 || r.top > window.innerHeight; stk.classList.toggle('on', fora && window.scrollY > 200); };
      window.addEventListener('scroll', vis, { passive: true }); window.addEventListener('resize', vis); vis();
    }
    marcaIndisponiveis(); kitTotal();
  }

  function recomenda(el) {
    var id = el.dataset.prod, sec = el.dataset.sec;
    if (!id || !sec) return;
    fetch('/recommendations/products?product_id=' + id + '&limit=12&section_id=' + sec)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (h) {
        if (!h) return;
        var tmp = document.createElement('div'); tmp.innerHTML = h;
        var novo = tmp.querySelector('.lj-vt__track');
        if (novo && novo.children.length >= 2) { el.querySelector('.lj-vt__track').innerHTML = novo.innerHTML; el.querySelector('.lj-vt__track').dispatchEvent(new Event('scroll')); }
      }).catch(function () {});
  }

  function cabecalho(el) {
    var abre = function (n) { var d = el.querySelector('[data-lj-dw="' + n + '"]'); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; var i = d.querySelector('input[type=search]'); if (i) setTimeout(function () { i.focus(); }, 200); };
    var fecha = function () { $$(el, '.lj-dw').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); }); document.documentElement.style.overflow = ''; };
    $$(el, '[data-lj-open]').forEach(function (b) { b.addEventListener('click', function () { abre(b.dataset.ljOpen); }); });
    $$(el, '[data-lj-close]').forEach(function (b) { b.addEventListener('click', fecha); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fecha(); });
    var rola = function () { el.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', rola, { passive: true }); rola();
  }

  function inicia() {
    $$(document, '[data-lj-hd]').forEach(cabecalho);
    $$(document, '[data-lj-rec]').forEach(recomenda);
    $$(document, '[data-lj-hero]').forEach(hero);
    $$(document, '[data-lj-vt]').forEach(vitrine);
    $$(document, '[data-lj-lk]').forEach(monte);
    $$(document, '[data-lj-col]').forEach(colecao);
    $$(document, '[data-lj-prod]').forEach(produto);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia); else inicia();
})();
